<template>
  <div>
    <Form
      inline
      class="bill-form"
      :label-width="60"
      label-position="left"
      @submit.native.prevent
    >
      <FormItem :label="$t('keyword')" style="width: 100%">
        <Input
          ref="input"
          v-model="keywords"
          :placeholder="$t('enter') + $t('keyword')"
          :disabled="disabled"
          @on-enter="enterClick(keywords)"
        >
        </Input>
      </FormItem>
    </Form>
    <Row :gutter="10" class="order-div">
      <Col span="4" class="table-class">
        <Table
          :columns="tableTitle"
          :data="tableData"
          border
          height="580"
          stripe
        >
        </Table>
      </Col>

      <Col span="20">
        <Row :gutter="10">
          <Col
            span="6"
            v-for="(item, index) in list"
            :key="item.id"
            style="margin-bottom: 5px"
          >
            <Card :bordered="false" style="background: #e8eaec">
              <p slot="title" class="text-red">
                <span>{{ list.length - index }}</span>
                <span
                  @click="delBtn(item.virtual_airway_number)"
                  style="font-size: 14px; cursor: pointer"
                  ><Icon type="md-close"
                /></span>
              </p>
              <p class="text-green">{{ item.virtual_airway_number }}</p>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
</template>
<script>
import {
  getDetails,
  postCargoOrder,
  addCargoOrder,
  getGoodMusic,
  deletePackage,
} from "@/api/order/package";

// import boxMes from "@/utils/message";
export default {
  props: {
    itemId: {
      type: Number,
    },
  },
  data() {
    return {
      keywords: "",
      list: [],
      loading: true,
      disabled: false,
      autofocus: true,
      autofocus1: false,
      tableData: [],
      goodsData: {},
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("order_number"),
        key: "bar_code",
        align: "center",
        // minWidth: 100,
        tooltip: true,
      });
      return columns;
    },
  },
  mounted() {
    this.SearchSubmit();
  },
  methods: {
    inputFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    enterClick(val) {
      if (!val) {
        this.$Message["error"]({
          background: true,
          content: "关键字不能为空",
          duration: 5,
        });
        return;
      }
      if (val != "CREATEORDER") {
        this.keywords = "";
        let flag = false;
        this.tableData.forEach((item) => {
          if (
            item.bar_code == val.toUpperCase() ||
            item.bar_code == val.toLowerCase()
          ) {
            flag = true;
            return;
          }
        });
        if (flag) {
          this.$Message["error"]({
            background: true,
            content: "请不要重复录入 !!!",
            duration: 5,
          });
          return;
        }
        postCargoOrder({ awb: val }).then((res) => {
          // let play = true;
          // if (res.data.status) {
          res.data.status && this.tableData.push({ bar_code: val });
          // play = this.goodsPlayMusic(res.data.payload.goods);
          // }
          // play && this.resMsg(res);
          this.resMsg(res);
        });
      } else {
        this.keywords = "";
        if (this.tableData.length == 0) {
          this.$Message["error"]({
            background: true,
            content: "运单号不能为空",
            duration: 5,
          });
          return;
        }
        let airway_number = this.tableData.map((item) => {
          return item.bar_code;
        });
        addCargoOrder(this.itemId, { airway_number: airway_number }).then(
          (res) => {
            this.resMsg(res);
            this.tableData = [];
            this.SearchSubmit();
          }
        );
      }
    },
    async goodsPlayMusic(goods) {
      let bool = true;
      let skuName = [];
      goods.forEach((item) => {
        if (this.goodsData[item.title]) {
          if (item.quantity + this.goodsData[item.title].quantity > 5) {
            if (!skuName.includes(item.title)) skuName.push(item.title);
            bool = false;
          } else {
            this.goodsData[item.title].quantity += item.quantity;
          }
        } else {
          this.goodsData[item.title] = {
            title: item.title,
            quantity: item.quantity,
          };
        }
      });
      if (skuName.length) {
        this.$Message["error"]({
          background: true,
          content: "商品" + skuName + "超过最大数量",
          duration: 5,
        });
        this.playMusic(await getGoodMusic({ title: skuName.join() }));
      }
      return bool;
    },
    // 删除合包
    delBtn(id) {
      this.$Modal.confirm({
        title:
          this.$t("whether") +
          this.$t("confirm") +
          this.$t("delete") +
          this.$t("orderNum") +
          "：" +
          id +
          "?",
        onOk: () => {
          deletePackage({ airway_number: id }).then((res) => {
            if (res.data.code === 0) {
              this.SearchSubmit();
              this.$Message.success("删除成功");
            }
          });
        },
      });
    },

    resMsg(res) {
      this.playMusic(res);
      if (res.data.status) {
        this.$Message["success"]({
          background: true,
          content: res.data.msg,
        });
      }
    },
    playMusic(res) {
      // console.log(res.data.payload.voice);
      let audio = new Audio();
      audio.src = this.$globalUrl + res.data.payload.voice;
      console.log(audio.src);
      audio.play();
      this.disabled = false;
      this.inputFocus();
    },
    getList(id) {
      this.inputFocus();
      this.loading = true;
      getDetails(id)
        .then((res) => {
          this.loading = false;
          this.list = res.data.payload;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    SearchSubmit() {
      this.getList(this.itemId);
    },
  },
};
</script>

<style scoped>
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
.ivu-card-head p,
.ivu-card-head-inner.text-red {
  color: red;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.order-div {
  padding: 10px 0;
  height: 600px;
}
.text-green {
  color: #19be6b;
  font-weight: bold;
}
.ivu-card-head {
  border-bottom: 1px solid #fff !important;
}
.table-class {
  height: 100%;
}
.ivu-col-span-20 {
  height: 100% !important;
  overflow: auto;
}
</style>
